import { render, staticRenderFns } from "./videoCopy.vue?vue&type=template&id=161a0d4f&scoped=true&"
import script from "./videoCopy.vue?vue&type=script&lang=js&"
export * from "./videoCopy.vue?vue&type=script&lang=js&"
import style0 from "./videoCopy.vue?vue&type=style&index=0&id=161a0d4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161a0d4f",
  null
  
)

export default component.exports